<template>
  <div>
    <!-- header-->
    <headertop></headertop>

    <div class="main">
      <div class="title">
        <h1 class="left"><i class="el-icon-star-off"></i> 我的收藏</h1>
      </div>
      <!-- 表格 -->
      <el-table :data="collect.list" stripe style="width: 90%;margin: 0 5%;" fit>
        <el-table-column prop="time" sortable label="时间">
        </el-table-column>
        <el-table-column prop="video.video" sortable label="文件/视频名称">
        </el-table-column>
        <el-table-column prop="video.type" sortable label="分类">
        </el-table-column>
        <el-table-column prop="video.teacher" sortable label="讲师">
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="collect_watch(scope.row)" size="mini" icon="el-icon-view" >查看</el-button>
            <el-popconfirm
              confirm-button-text='确定'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="删除之后不可恢复,是否确认删除？"
              @confirm="collect_del(scope.row)"
            >
              <el-button size="mini" type="danger" slot="reference" icon="el-icon-delete">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页-->
      <div class="block center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="collect.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="collect.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="collect.total">
        </el-pagination>
      </div>
    </div>
    <!-- footer -->
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        collect:{
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: ''
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer
    },
    mounted:function(){
      this.get_collect()
    },
    methods: {
      get_collect(){
        let _this=this;
        _this.axios.get('/v2/user/get_collect',{params:{page:_this.collect.currentPage,limit:_this.collect.pageSize}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.collect=res.data.data
              _this.collect.pageSize=parseInt(_this.collect.pageSize)
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      collect_watch(row) {
        if(row.resource_type=='video'){
          this.$router.push({path:'/courseplay',query:{num:row.v_num,'type':row.type,'resource':'v'}})
        }else{
          // this.$router.push({path:'/FileQCregister',query:{num:row.v_num}})
          this.$router.push({path:'/filetow',query:{num:row.v_num}})
        }
      },
      collect_del(row) {
        let _this=this
        _this.axios.post('/v2/user/collect_del',{data:row}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_collect()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        this.collect.currentPage = 1;
        this.collect.pageSize = val;
        this.get_collect()
      },
      handleCurrentChange(val) {
        this.collect.currentPage = val;
        this.get_collect()
      },
    },
  }
</script>

<style scoped>
  .header_div {
    z-index: 9999;
  }

  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;
  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Mine/Collect/Collect.vue